import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { AssetSize } from '../../../types/isomorphic/assetSize.types';
import queryKeys from '../../support/uiStateKeys';
import useDownloadModifiedAsset from '../../hooks/useDownloadModifiedAsset';

export const ORIGINAL_SIZE_KEY = queryKeys.ORIGINAL_SIZE;

const originalSizeInitialData = {
  name: '',
  label: '',
  teeShirtSize: '',
} as unknown as AssetSize;

export default function useOriginalSize(): {
  originalSize: AssetSize;
  setOriginalSize: (size: AssetSize) => void;
} {
  const queryClient = useQueryClient();
  const { genId: genRequestId, index } = useDownloadModifiedAsset();

  const setOriginalSize = useCallback(
    (size: AssetSize) => {
      queryClient.setQueryData([ORIGINAL_SIZE_KEY, genRequestId, index], size);
    },
    [genRequestId, index, queryClient]
  );

  const { data } = useSuspenseQuery<AssetSize>({
    queryKey: [ORIGINAL_SIZE_KEY, genRequestId, index],
    queryFn: ({ queryKey }) =>
      (queryClient.getQueryData(queryKey) as AssetSize) ||
      originalSizeInitialData,
    initialData: () => originalSizeInitialData,
  });

  return {
    originalSize: data,
    setOriginalSize,
  };
}
